import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Navbar from './components/navbar';
import Footer from './components/footer';
import Products from './Products';


const pages = {
  "" : <App/>,
  "index" : <App/>,
  "home" : <App/>,
  "products" : <Products/>,

}

const top = ReactDOM.createRoot(document.getElementById('top'));
const root = ReactDOM.createRoot(document.getElementById('root'));
const bottom = ReactDOM.createRoot(document.getElementById('bottom'));
let path = window.location.pathname.split('/')
path.splice(0,1)


top.render(
  <React.StrictMode>
   <Navbar/>
  </React.StrictMode>
);
root.render(
  <React.StrictMode>
    {pages[path[0]]}
  </React.StrictMode>
);
bottom.render(
  <React.StrictMode>
   <Footer/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
